import { Icon } from "@opendash/icons";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {
  value: number;
  style?: React.CSSProperties;
};

export const PriorityIcon = observer((props: Props) => {
  return (
    <Icon
      icon="fa:signal"
      strokeWidth="40px"
      mask={`linear-gradient(90deg, black ${props.value}%, #FFFFFF55 ${props.value + 1}%)`}
      style={props.style}
    />
  );
});
